import React from "react";
import { Redirect, useLocation } from "react-router-dom";

import { ACCESS_TOKEN } from "../../constants/app.constants";
import { ROUTES } from "../../constants/routes.constants";
import AccessDenied from "../access-denied/access-denied.component";

const PrivateComponent = ({ children, showAccessDenied = true }) => {

   const prevLocation = useLocation();
   console.log(prevLocation);
   const isLoggedIn = !!localStorage.getItem(ACCESS_TOKEN);
   return isLoggedIn ? children : showAccessDenied && <Redirect to={`${ROUTES.LOGIN}?redirectTo=${prevLocation?.pathname}`}/>;
};

export default PrivateComponent;